import { AlertDialog, AlertDialogOverlay,AlertDialogHeader, AlertDialogContent, AlertDialogBody, AlertDialogFooter ,Button} from "@chakra-ui/react";

function ConfirmDialog(props) {
  const onClick =()=>{
    props.onClose()
    props.onReset()
  }
    return (
      <>
        <AlertDialog
          isOpen={props.isOpen}
          leastDestructiveRef={props.onClose}
          onClose={props.onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {props.header}
              </AlertDialogHeader>
  
              <AlertDialogBody>
                {props.body}
              </AlertDialogBody>
              <AlertDialogFooter>
                <Button onClick={props.onClose}>
                  Cancel
                </Button>
                <Button colorScheme="blue" onClick={onClick} ml={3}>
                  Confirm
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </>
    )
  }

  export default ConfirmDialog;
